export const getCustomersAsOptions = state => {
  const { customersByAmsId } = state.newQuote.steps.customer;
  return [...customersByAmsId.values()].map(c => ({
    value: c.agency_management_system_id,
    label: c.name
  }));
};
